import { LineLayerSpecification } from 'mapbox-gl';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

export const platformPerimeterLayer: LineLayerSpecification = {
  id: LayerNameEnum.PLATFORM_PERIMETER,
  type: 'line',
  source: SourceNameEnum.PLATFORMS,
  filter: ['==', 'featureType', FeatureTypeEnum.PLATFORM_PERIMETER],
  paint: {
    'line-color': 'white',
    'line-width': 3,
  },
};

export const platformOutlineLayer: LineLayerSpecification = {
  id: LayerNameEnum.PLATFORM_OUTLINES,
  type: 'line',
  source: SourceNameEnum.PLATFORMS,
  filter: ['==', 'featureType', FeatureTypeEnum.PLATFORM_PERIMETER],
  paint: {
    'line-color': 'black',
    'line-width': 7,
  },
};
